<template lang='pug'>
v-layout(class='list' row wrap)
  v-flex(xs12 sm6 md4)
    v-list(dense)
      v-list-tile
        v-list-tile-content(class='grey--text') Менеджер:
        v-list-tile-content(class='align-end font-weight-medium') {{ step.step_info.manager }}
  v-flex(xs12)
    rhtml(:html='step.html')
  v-flex(xs12)
    images(:images='step.images')
</template>

<script>
import Html from './Html'
import Images from './Images'

export default {
  props: ['step'],
  components: {
    Rhtml: Html,
    Images
  }
}
</script>

<style scoped>
.list >>> .v-list__tile {
  padding-right: 0;
  padding-left: 0;
}
</style>
